<template>
  <v-container fluid>
    <v-tabs
      color="transparent"
      v-model="tab"
      show-arrows
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-layout align-center justify-space-between>
        <span>
          <v-tab v-for="tabItem in tabs" :key="tabItem">
            {{ tabItem }}
          </v-tab>
        </span>
        <span>
          {{ $t('balance') }}: $ {{ systemBalance.balance }}
        </span>
      </v-layout>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item>
          <v-layout>
            <v-flex xs3 md2>
              <v-btn dark color="primary" @click.stop="showCreateLabelDialog()"><v-icon dark>add</v-icon>{{ $t('domesticLabel') }}</v-btn>
            </v-flex>
            <v-flex xs3 md2>
              <v-btn dark color="primary" @click.stop="showCreateLabelInternationalDialog()"><v-icon dark>add</v-icon>{{ $t('exportFromUS') }}</v-btn>
            </v-flex>
            <v-flex xs3 md2>
              <v-btn dark color="primary" @click.stop="showCreateLabelImportDialog()"><v-icon dark>add</v-icon>{{ $t('importToUS') }}</v-btn>
            </v-flex>
            <v-flex xs3 md2>
              <v-btn
                :dark="visibleBetaFeatures.includes('FEDEX_LTL')"
                color="primary"
                @click.stop="showCreateFreightLabelDialog()"
                :disabled="!visibleBetaFeatures.includes('FEDEX_LTL')"
              >
                <v-icon dark>add</v-icon>{{ $t('freightLabel') }}
              </v-btn>
            </v-flex>

            <v-flex xs3 md2 v-if="checkPathAnnouncement($route.path)">
              <v-tooltip top>
                 <template v-slot:activator="{ on }">
                    <v-btn  v-on="on" icon @click.stop="showPathAnnouncement($route.path)"><v-icon color="blue">info</v-icon></v-btn>
                  </template>
                  {{ $t('importantInformation') }}
              </v-tooltip>
            </v-flex>
          </v-layout>
          <PaginationController
            v-model="labels"
            getDataActionName="getLabelPagination"
            :historyLimit="historyLimit"
            :select="selectText"
            haveStartDate
            :startDate="startDate"
            :showSearchBoxLabel="false"
            :actionPredicates="generatePredicate()"
            isPagination
          >
            <template v-slot:dataTable>
              <v-data-table
                :headers="headers"
                :items="labels"
                hide-actions
                item-key="_key"
                select-all="blue"
                v-model="selectedFilteredLabels"
              >
                <template v-slot:items="props">
                  <td class="checkbox-align-center" @click="props.item.url && props.item.status !== 'canceled' && (props.selected = !props.selected)">
                    <v-layout>
                      <v-checkbox
                        :disabled="!props.item.url || props.item.status === 'canceled'"
                        @click.stop="() => { props.selected = !props.selected }"
                        :value="props.selected"
                        primary
                        hide-details
                      ></v-checkbox>
                    </v-layout>
                  </td>
                  <td class="text-xs-left">
                    <LabelDetailsWidget :shipmentLabel="props.item" :index="props.index" />
                  </td>
                  <td class="text-xs-left">
                    <LabelAddressWidget
                      :address="props.item.from"/>
                  </td>
                  <td class="text-xs-left">
                    <LabelAddressWidget
                      :address="props.item.to"/>
                  </td>
                  <td v-if="$store.getters.activeWarehouse" class="text-xs-left">
                    {{ organizationKeyToId.get(props.item.clientKey) }}
                  </td>
                  <td class="text-xs-left">
                    <v-layout>
                      {{ toDateYYYYMMDD(props.item.createTime) }}
                    </v-layout>
                    <v-layout>
                      {{ props.item.shipDate }}
                    </v-layout>
                    <v-layout v-if="props.item.estimatedDelivery && props.item.estimatedDelivery !== 'N/A'" class="text-capitalize">
                      <v-flex v-if="typeof props.item.estimatedDelivery === 'string'">{{
                        toDateYYYYMMDD(new Date(props.item.estimatedDelivery))
                      }}</v-flex>
                      <v-flex v-else>{{ toDateYYYYMMDD(props.item.estimatedDelivery) }}</v-flex>
                    </v-layout>
                  </td>
                  <td class="text-xs-left">
                    <template v-if="props.item.status !== 'failed'">
                      <LabelTrackingDetailWidget
                        :trackingNumber="props.item.trackingNumber"
                        :status="props.item.status"
                        :carrier="props.item.carrier"
                        :details="props.item.trackingDetails"
                      />
                      <div v-if="['ready', 'in transit', 'delivered'].includes(props.item.status) && !!props.item.trackStatus">{{ props.item.trackStatus.toLowerCase() }}</div>
                    </template>
                    <div v-else>
                      <p :key="messageItem.time" v-for="messageItem in props.item.messages" >
                        {{messageItem.message}}
                      </p>
                    </div>
                  </td>
                  <td class="text-xs-left">
                    <v-layout v-if="props.item.carrier">
                      <strong>{{ props.item.carrier }}</strong>
                    </v-layout>
                    <v-layout>
                      {{ props.item.serviceDescription }}
                    </v-layout>
                  </td>
                  <td :class="props.item.totalAmount ? 'text-xs-left fontRed' : (props.item.amount > 0 ? 'text-xs-left fontGreen' : 'text-xs-left fontRed')">
                    ${{ -props.item.totalAmount || props.item.amount || 0 }}
                  </td>
                  <td class="text-xs-left">
                    <span :style="{backgroundColor: isLabelOverOneWeek(props.item) ? 'yellow' : ''}">
                      {{ props.item.status || 'ready' }}
                    </span>
                  </td>
                  <td class="text-xs-center">
                    <v-layout row justify-center>
                      <span v-if="props.item.status === 'pending' && env !== 'production'">
                        <v-tooltip top>
                          <template v-slot:activator="tooltip">
                            <div v-on="tooltip.on">
                              <LoaderButton
                                flat
                                :promiseAwait="getLabelStatus"
                                :promiseItem="props.item"
                                buttonIcon='refresh'
                              ></LoaderButton>
                            </div>
                          </template>
                          {{ $t('getStatus') }}
                        </v-tooltip>
                      </span>
                      <span v-else>
                        <v-tooltip top>
                          <template v-slot:activator="tooltip">
                            <div v-on="tooltip.on">
                              <v-btn
                                flat
                                icon
                                :color="props.item.isDownloaded ? 'success' : 'primary'"
                                @click.stop="downloadFile(props.item.url, props.item.orderKey, props.item._key)"
                                :disabled="!props.item.url || ['canceled', 'failed'].includes(props.item.status)"
                              ><v-icon>preview</v-icon></v-btn>
                            </div>
                          </template>
                          {{ $t('openLabel') }}
                        </v-tooltip>
                      </span>
                      <span v-if="props.item.invoiceUrl">
                        <v-tooltip top>
                          <template v-slot:activator="tooltip">
                            <div v-on="tooltip.on">
                              <v-btn
                                flat
                                icon
                                color="orange"
                                @click.stop="downloadFile(props.item.invoiceUrl, props.item.orderKey, props.item._key)"
                                :disabled="['canceled', 'failed'].includes(props.item.status)"
                              ><v-icon>receipt</v-icon></v-btn>
                            </div>
                          </template>
                          {{ $t('downloadInvoice') }}
                        </v-tooltip>
                      </span>
                      <span>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-tooltip top>
                              <template v-slot:activator="tooltip">
                                <div v-on="tooltip.on">
                                  <v-btn @click.stop="on.click" dark icon flat color="primary">
                                    <v-icon>build</v-icon>
                                  </v-btn>
                                </div>
                              </template>
                              {{ $t('more') }}
                            </v-tooltip>
                          </template>
                          <v-list>
                            <v-list-tile class="list-tile-center">
                              <LoaderButton
                                flat
                                :buttonText="$t('editNote')"
                                :promiseAwait="showEditLabelDialog"
                                :promiseItem="props.item"
                              ></LoaderButton>
                            </v-list-tile>
                            <v-list-tile
                              v-if="props.item.requestId === props.item._key"
                              class="list-tile-center"
                            >
                              <LoaderButton
                                flat
                                :buttonText="$t('reShip')"
                                :promiseAwait="copyLabel"
                                :promiseItem="props.item"
                              ></LoaderButton>
                            </v-list-tile>
                            <v-list-tile
                              class="list-tile-center"
                              v-if="props.item.carrier !== 'USPS' &&
                                (props.item.status === 'ready' || props.item.status === 'pending') &&
                                (props.item.requestId === props.item._key)"
                            >
                              <v-tooltip top>
                                <template v-slot:activator="tooltip">
                                  <div v-on="tooltip.on">
                                    <LoaderButton
                                      flat
                                      :buttonText="$t('cancel')"
                                      :promiseAwait="cancelLabel"
                                      :disabled="visibleBetaFeatures.includes('cancelLabelByDownloaded') && props.item.isDownloaded"
                                      :promiseItem="props.item"
                                    ></LoaderButton>
                                  </div>
                                </template>
                                {{ props.item.isDownloaded ? $t('contactToCancelLabel') : $t('cancel') }}
                              </v-tooltip>
                            </v-list-tile>
                            <v-list-tile
                              class="list-tile-center"
                              v-if="(props.item.carrier && props.item.carrier.toUpperCase() === 'FEDEX' && props.item.isProofDelivery)"
                            >
                              <LoaderButton
                                flat
                                :buttonText="$t('updateProofDelivery')"
                                :promiseAwait="updateProofDelivery"
                                :promiseItem="props.item"
                              ></LoaderButton>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </span>
                    </v-layout>
                  </td>
                </template>
              </v-data-table>
            </template>
            <template v-slot:afterDate>
              <v-flex>
                <v-layout align-center justify-end>
                  <v-flex xs5>
                    <v-switch :label="isMergePDF ? 'PDF' : 'ZIP'" v-model="isMergePDF"></v-switch>
                  </v-flex>
                  <v-flex xs6>
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, props }">
                        <v-btn
                          small
                          color="primary"
                          v-bind="props"
                          v-on="on"
                        >
                          {{ $t('export') }}
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-tile class="list-tile-center">
                          <LoaderButton
                            flat
                            :buttonText="$t('downloadLabelsNum', { selectedLabelsLength: selectedLabels.length })"
                            :promiseAwait="downloadSelectedLabelAndZip"
                            :disabled="selectedLabels.length === 0"
                          />
                        </v-list-tile>
                      </v-list>
                      <v-list>
                        <v-list-tile class="list-tile-center">
                          <v-btn flat color="primary" @click="showExportLabelsPopup" :loading="exportLabelsPopup.loading">
                            {{ $t('exportLabels') }}
                          </v-btn>
                        </v-list-tile>
                      </v-list>
                      <v-list>
                        <v-list-tile class="list-tile-center">
                          <v-btn flat color="primary" @click="exportLabelsToExcel({ labels: selectedLabels })" :disabled="selectedLabels.length === 0">
                              {{ $t('exportSelectedLabels') }}({{ selectedLabels.length }})
                            </v-btn>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
            <template v-slot:beforeMenu>
              <v-layout justify-start>
                <v-flex xs3 mr-1>
                  <v-select
                    :items="[
                      { name: $t('keyword'), value: 'keyword' },
                      { name: $t('batchByRequestId'), value: 'requestIds' },
                      { name: $t('batchByTracking'), value: 'trackings' },
                    ]"
                    item-value="value"
                    item-text="name"
                    v-model="searchMode"
                    @change="
                      e => {
                        searchText = ''
                        requestIds = []
                        selectText = ''
                        searchTrackings = []
                        trackStatusValue = ''
                      }
                    "
                    :label="$t('searchMode')"
                  ></v-select>
                </v-flex>
                <v-flex xs8 pl-3 v-if="searchMode === 'requestIds'">
                  <v-combobox
                    :label="`${$t('requestId')}(max: 10)`"
                    v-model="requestIds"
                    small-chips
                    deletable-chips
                    :return-object="false"
                    :hint="`${$t('requestId')} **${$t('enterToNext')}`"
                    multiple
                    @change="changeBatchSearch(requestIds, 'requestIds')"
                    clearable
                  />
                </v-flex>
                <v-flex xs8 pl-3 v-if="searchMode === 'trackings'">
                  <v-combobox
                    :label="`${$t('tracking')}(max: 10)`"
                    v-model="searchTrackings"
                    small-chips
                    deletable-chips
                    @change="changeBatchSearch(searchTrackings, 'searchTrackings')"
                    :return-object="false"
                    :hint="`${$t('trackingNumber')} **${$t('enterToNext')}`"
                    multiple
                    clearable
                  />
                </v-flex>
                <template v-if="searchMode === 'keyword'">
                  <v-flex xs2>
                    <v-autocomplete
                      :items="labelStatusArray"
                      item-value="value"
                      item-text="name"
                      v-model="selectText"
                      :label="$t('labelStatus')"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs2 ml-1>
                    <v-autocomplete
                      :items="trackStatusArray"
                      item-value="value"
                      item-text="name"
                      v-model="trackStatusValue"
                      :label="$t('trackStatus')"
                    ></v-autocomplete>
                  </v-flex>
                <v-flex xs3  ml-3>
                  <v-text-field
                    :hint="`${$t('memo')}/${$t('recipient')}/${$t('serviceType')}/${$t('tracking')}`"
                    :label="$t('search')"
                    v-model="searchText"
                    clearable
                  ></v-text-field>
                </v-flex>
                </template>
              </v-layout>
            </template>
          </PaginationController>
        </v-tab-item>
        <v-tab-item v-if="isModeLabel">
          <ApiLabel style="padding: 0" />
        </v-tab-item>
        <v-tab-item>
          <v-layout>
            <v-flex xs2>
              <v-btn dark color="primary" @click.stop="showCreateAddressDialog"><v-icon dark>add</v-icon>{{ $t('address') }}</v-btn>
            </v-flex>
            <v-flex xs1 v-if="enableAmazonSites">
              <v-switch v-model="isOnlyShowCustomSites" :label="isOnlyShowCustomSites ? $t('custom') : $t('all')"></v-switch>
            </v-flex>
          </v-layout>
          <v-container fluid grid-list-lg>
            <v-layout wrap>
              <v-flex md2 v-for="address in addressesDisplay" :key="address.siteName">
                <LabelAddressCard
                  :address="address"
                  @delete="deleteAddress(address)"
                  @edit="showEditAddressDialog(address)"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-layout justify-space-between>
            <v-flex md2>
              <v-btn dark color="primary" @click.stop="showAddPackagingDialog"><v-icon dark>add</v-icon>{{ $t('packaging') }}</v-btn>
            </v-flex>
            <v-flex md2>
              <v-text-field
                append-icon="filter_list"
                class="text-xs-right"
                :label="$t('search')"
                single-line
                hide-details
                v-model="filter"
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="packagingHeaders"
            :items="packagings"
            class="my-1 levation-2 myDense"
            :rows-per-page-items="rowPerPage"
            :search="filter"
          >
            <template v-slot:items="props">
              <td class="subheading">{{ props.index + 1}}</td>
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-left">{{ props.item.length }} {{ props.item.isMeasurementMetric ? 'cm' : '"' }}</td>
              <td class="text-xs-left">{{ props.item.width }} {{ props.item.isMeasurementMetric ? 'cm' : '"' }}</td>
              <td class="text-xs-left">{{ props.item.height }} {{ props.item.isMeasurementMetric ? 'cm' : '"' }}</td>
              <td class="text-xs-left">{{ getPackagingWeightForDisplay(props.item) }}</td>
              <td class="text-xs-right">
                <v-layout row>
                  <v-flex><v-btn dark color="primary" flat @click.stop="showEditPackagingDialog(props.item)">{{ $t('edit') }}</v-btn></v-flex>
                  <v-flex><v-btn dark color="primary" flat @click.stop="deletePackaging(props.item)">{{ $t('delete') }}</v-btn></v-flex>
                </v-layout>
              </td>
            </template>
          </v-data-table>
        </v-tab-item>
        <ShippingTemplateTab style="padding: 0" />
        <LabelTemplateTab style="padding: 0" />
        <v-tab-item>
          <ProofDeliveryHistory style="padding: 0" />
        </v-tab-item>
        <CommodityTemplateTab />
      </v-tabs-items>
    </v-tabs>

    <LabelCreatePopup
      v-model="createLabelDialog"
      v-if="createLabelDialog"
      :froms="addresses"
      :idGenerator="labelIdGenerator"
      :labelInfo='labelInfo'
      :dangerousGoodsInfo.sync='dangerousGoodsInfo'
      :isFreight="isFreight"
      businessType="domestic"
      @submitted="updateLabelStatus"/>
    <LabelCreateAddress
      v-model="createAddressDialog"
      v-if="createAddressDialog"
      :actionFunc="addressFunc"
      :address="addressInEdit"
      :siteNames="siteNames"></LabelCreateAddress>
    <FormSubmitPopup
      :title="$t('packaging')"
      v-model="packagingDialog"
      v-if="packagingDialog"
      medium
      @popupClose="packagingDialog = false"
      :rightMethod="editPackaging"
      :rightButtonText="$t('submit')">
      <template v-slot:input>
        <v-container>
          <v-layout justify-space-between>
            <v-flex>
              <v-text-field
                :label="$t('name')"
                :rules="[fieldIsRequired()]"
                v-model="packagingInEdit.name"
                :disabled="isEdit"
                class="required_field"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-text-field
                :label="$t('length')"
                :rules="[fieldIsRequired(), fieldIsValidPkgInfo(), fieldIsOverZero()]"
                v-model.number="packagingInEdit.length"
                :suffix="$t(isMeasurementMetric ? 'cm' : 'inch')"
                class="required_field"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-text-field
                :label="$t('width')"
                :rules="[fieldIsRequired(), fieldIsValidPkgInfo(), fieldIsOverZero()]"
                v-model.number="packagingInEdit.width"
                :suffix="$t(isMeasurementMetric ? 'cm' : 'inch')"
                class="required_field"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-text-field
                :label="$t('height')"
                :rules="[fieldIsRequired(), fieldIsValidPkgInfo(), fieldIsOverZero()]"
                v-model.number="packagingInEdit.height"
                :suffix="$t(isMeasurementMetric ? 'cm' : 'inch')"
                class="required_field"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-text-field
                :label="$t('weight')"
                :rules="[fieldIsRequired(), fieldIsValidPkgInfo(), fieldIsOverZero()]"
                v-model.number="packagingInEdit.weight"
                :suffix="$t(isMeasurementMetric ? 'kg' : 'lb')"
                class="required_field"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
    </FormSubmitPopup>
    <FormSubmitPopup
      :title="$t('editNote')"
      v-model="editLabelDialog"
      v-if="editLabelDialog"
      medium
      @popupClose="editLabelDialog = false"
      :rightMethod="editLabel"
      :rightButtonText="$t('submit')">
      <template v-slot:input>
        <v-container>
          <v-layout justify-space-between>
            <v-flex>
              <v-text-field
                :label="$t('note')"
                :rules="[fieldCharLimit('Note', 100)]"
                v-model="labelInEdit.note"
                counter="100"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
    </FormSubmitPopup>
    <LabelCreateInternationalPopup
      v-model="createLabelInternationalDialog"
      v-if="createLabelInternationalDialog"
      :froms="addresses"
      :idGenerator="labelIdGenerator"
      :labelInfo='labelInfo'
      businessType="export"
      @submitted="updateLabelStatus"/>
    <LabelCreateImportToUsPopup
      v-model="createLabelImportDialog"
      v-if="createLabelImportDialog"
      :froms="addresses"
      :idGenerator="labelIdGenerator"
      :labelInfo='labelInfo'
      businessType="import"
      @submitted="updateLabelStatus"/>

    <FormSubmitPopup
      :title="$t('exportLabels')"
      v-model="exportLabelsPopup.show"
      :rightMethod="exportLabels"
      :rightButtonText="$t('export')"
      @popupClose="exportLabelsPopup.show = false"
      small
      hasAlert
    >
      <template v-slot:input>
        <v-layout>
          <v-flex>
            <DatePicker
              v-model="exportLabelsPopup.dates"
              :label="$t('date')"
              range
              :max="dateMax"
              :min="dateMin"
            />
          </v-flex>
        </v-layout>
      </template>
    </FormSubmitPopup>
  </v-container>
</template>

<script>
import LabelCreatePopup from './LabelCreatePopup'
import LabelCreateInternationalPopup from './LabelCreateInternationalPopup'
import LabelCreateImportToUsPopup from './LabelCreateImportToUsPopup.vue'
import ShippingTemplateTab from './ShippingTemplateTab.vue'
import LabelTemplateTab from './LabelTemplateTab.vue'
import CommodityTemplateTab from './CommodityTemplateTab.vue'
import LabelAddressWidget from './LabelAddressWidget'
import LabelCreateAddress from './LabelCreateAddress'
import LabelAddressCard from './LabelAddressCard'
import PaginationController from './PaginationController'
import LoaderButton from './LoaderButton'
import FormSubmitPopup from './FormSubmitPopup'
import LabelTrackingDetailWidget from './LabelTrackingDetailWidget'
import LabelDetailsWidget from './LabelDetailsWidget'
import ProofDeliveryHistory from './ProofDeliveryHistory'
import ApiLabel from './ApiLabel.vue'
import DatePicker from './DatePicker.vue'
import { checkRules, timeTools, getRandomIdByTime, measurementTools, downloadLabelFile, cloneDeep, splitKeyword, convertTimestampToDateInObj } from '../utils/tools'
import { mapGetters } from 'vuex'

export default {
  name: 'Label',
  components: {
    PaginationController,
    LabelCreatePopup,
    LabelAddressCard,
    LabelAddressWidget,
    LabelCreateAddress,
    LoaderButton,
    FormSubmitPopup,
    ShippingTemplateTab,
    LabelTemplateTab,
    CommodityTemplateTab,
    LabelTrackingDetailWidget,
    LabelCreateInternationalPopup,
    LabelDetailsWidget,
    ProofDeliveryHistory,
    LabelCreateImportToUsPopup,
    DatePicker,
    ApiLabel
  },
  mixins: [checkRules, timeTools, measurementTools],
  data () {
    const now = new Date()
    return {
      tab: null,
      rowPerPage: [15, 30, 50, {text: this.$t('all'), value: -1}],
      createLabelDialog: false,
      headers: this.$store.getters.activeWarehouse ? [
        { text: this.$t('details'), value: 'signature', align: 'left', sortable: false, width: '20%' },
        { text: this.$t('from'), value: 'from', align: 'left', sortable: false },
        { text: this.$t('to'), value: 'to', align: 'left', sortable: false },
        { text: this.$t('creator'), value: 'clientKey', align: 'left', sortable: false },
        { text: this.$t('create/ship/estDeliveryDate'), value: 'createTime', align: 'left', sortable: false },
        { text: this.$t('tracking/info'), value: 'trackingNumber', align: 'left', sortable: false },
        { text: this.$t('service'), value: 'shippingService', align: 'left', sortable: false },
        { text: this.$t('amount'), value: 'amount', align: 'left', sortable: false },
        { text: this.$t('status'), value: 'status', align: 'left', sortable: false },
        { text: this.$t('actions'), value: '', align: 'center', sortable: false }
      ] : [
        { text: this.$t('details'), value: 'signature', align: 'left', sortable: false, width: '20%' },
        { text: this.$t('from'), value: 'from', align: 'left', sortable: false },
        { text: this.$t('to'), value: 'to', align: 'left', sortable: false },
        { text: this.$t('create/ship/estDeliveryDate'), value: 'createTime', align: 'left', sortable: false },
        { text: this.$t('tracking/info'), value: 'trackingNumber', align: 'left', sortable: false },
        { text: this.$t('service'), value: 'shippingService', align: 'left', sortable: false },
        { text: this.$t('amount'), value: 'amount', align: 'left', sortable: false },
        { text: this.$t('status'), value: 'status', align: 'left', sortable: false },
        { text: this.$t('actions'), value: '', align: 'center', sortable: false }
      ],
      packagingHeaders: [
        { text: '#', value: 'id', align: 'left', sortable: false },
        { text: this.$t('name'), value: 'name', align: 'left', sortable: false },
        { text: this.$t('length'), value: 'length', align: 'left', sortable: false },
        { text: this.$t('width'), value: 'width', align: 'left', sortable: false },
        { text: this.$t('height'), value: 'height', align: 'left', sortable: false },
        { text: this.$t('weight'), value: 'weight', align: 'left', sortable: false },
        { text: this.$t('actions'), value: '', align: 'center', sortable: false, width: '10%' }
      ],
      historyLimit: 25,
      productInEdit: {},
      refresh: false,
      labels: [],
      tempLabelStatusUnsubs: {},
      tempLabelStatusBaseline: {},
      createAddressDialog: false,
      addressInEdit: {},
      packagingInEdit: {},
      packagingDialog: false,
      editLabelDialog: false,
      labelInEdit: {},
      isEdit: false,
      selectedLabels: [],
      filter: '',
      labelStatusArray: [
        {name: `-- ${this.$t('all')} --`, value: ''},
        {name: this.$t('pending'), value: 'pending'},
        {name: this.$t('ready'), value: 'ready'},
        {name: this.$t('inTransit'), value: 'in transit'},
        {name: this.$t('delivered'), value: 'delivered'},
        {name: this.$t('canceled'), value: 'canceled'}
      ],
      trackStatusArray: [
        {name: `-- ${this.$t('all')} --`, value: ''},
        {name: this.$t('created'), value: 'CREATED'},
        {name: this.$t('inTransit'), value: 'IN_TRANSIT'},
        {name: this.$t('exception'), value: 'EXCEPTION'},
        {name: this.$t('delivered'), value: 'DELIVERED'},
        {name: this.$t('canceled'), value: 'CANCELED'}
      ],
      selectText: '',
      trackStatusValue: '',
      isMergePDF: false,
      isOnlyShowCustomSites: true,
      createLabelInternationalDialog: false,
      labelInfo: {
        from: {},
        to: {},
        packages: [],
        commodities: [],
        shippingService: '',
        note: '',
        memo: '',
        signature: '',
        shipmentPurpose: '',
        shipmentMemo: ''
      },
      dangerousGoodsInfo: {},
      isFreight: false,
      requestIds: [],
      searchMode: 'keyword',
      searchText: '',
      searchTrackings: [],
      createLabelImportDialog: false,
      exportLabelsPopup: {
        show: false,
        dates: [new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000), now],
        loading: false
      },
      startDate: new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000)
    }
  },
  async mounted () {
    this.isMergePDF = window.localStorage.getItem('isMergePDF' + this.$store.getters.uid) === 'true'
    this.$store.getters.activeOrganization && this.$store.dispatch('syncEeveeBalance')
    if (this.$store.getters.activeOrganization || this.$store.getters.activeWarehouse) {
      this.$store.dispatch('getCommodityTemplates')
    }
  },
  beforeDestroy () {
    Object.keys(this.tempLabelStatusUnsubs || {}).forEach(requestId => this.cleanupTempLabelSubscription(requestId))
  },
  watch: {
    isMergePDF (val) {
      window.localStorage.setItem('isMergePDF' + this.$store.getters.uid, val)
    },
    tab () {
      this.filter = ''
    },
    createLabelDialog (val) {
      if (!val) this.isFreight = false
    },
    labels (newLabels) {
      this.scanAndSubscribePendingLabels(newLabels)
    }
  },
  computed: {
    ...mapGetters(['activeOrganization', 'activeWarehouse', 'isModeLabel']),
    tabs () {
      const tabs = [
        this.$t('label'),
        this.$t('address'),
        this.$t('packaging'),
        this.$t('orderTemplate'),
        this.$t('labelTemplate'),
        this.$t('proofDeliveryHistory'),
        this.$t('commodityTemplate')
      ]
      if (this.isModeLabel) {
        tabs[0] = this.$t('viteLabel')
        tabs.splice(1, 0, this.$t('apiLabel'))
      }
      return tabs
    },
    dateMin () {
      const [startDate, endDate] = this.exportLabelsPopup.dates
      if (startDate && endDate) return undefined
      if (startDate) {
        const monthTime = 31 * 60 * 60 * 24 * 1000
        const time = startDate.getTime() - monthTime
        return new Date(time).toISOString()
      }
      return undefined
    },
    dateMax () {
      const [startDate, endDate] = this.exportLabelsPopup.dates
      const now = new Date()
      if (startDate && endDate) return now.toISOString()
      if (startDate) {
        const monthTime = 31 * 60 * 60 * 24 * 1000
        const time = startDate.getTime() + monthTime
        return now.getTime() < time ? now.toISOString() : new Date(time).toISOString()
      }
      return now.toISOString()
    },
    visibleBetaFeatures () {
      return this.$store.getters.visibleBetaFeatures || []
    },
    selectedFilteredLabels: {
      get: function () {
        return this.selectedLabels
      },
      set: function (val) {
        this.selectedLabels = val.filter(item => item.url && item.status !== 'canceled')
      }
    },
    env () {
      return process.env.NODE_ENV
    },
    isMeasurementMetric () {
      return this.$store.getters.isMeasurementMetric
    },
    enableAmazonSites () {
      return this.$store.getters.enableAmazonSites
    },
    addressesDisplay () {
      if (this.isOnlyShowCustomSites) {
        return this.addresses.filter(item => !item.isAmazon)
      }
      return this.addresses
    },
    addresses () {
      return this.$store.getters.tenantAddresses
    },
    siteNames () {
      let names = new Set(this.addresses.map(item => item.siteName))
      names.delete(this.addressInEdit.siteName)
      return names
    },
    organizationKeyToId () {
      return this.$store.getters.organizationKeyToId
    },
    packagings () {
      return this.$store.getters.tenantPackagings
    },
    packagingMap () {
      return this.$store.getters.packagingMap
    },
    templates () {
      return this.$store.getters.templates
    },
    systemBalance () {
      return this.$store.getters.systemBalance
    },
    isRestrictInternationalLabel () {
      return this.$store.getters.isRestrictInternationalLabel
    },
    otherServices () {
      return this.$store.getters.otherServices
    }
  },
  methods: {
    async exportLabels () {
      try {
        this.exportLabelsPopup.loading = true
        this.exportLabelsPopup.show = false
        const [startDate, endDate] = this.exportLabelsPopup.dates
        const labels = await this.$store.dispatch('getLabelPagination', {
          startDate,
          endDate
        })
        this.exportLabelsPopup.loading = false
        return this.exportLabelsToExcel(
          {
            labels: labels.docs.map(doc => convertTimestampToDateInObj(doc.data())),
            startDate,
            endDate
          }
        )
      } catch (err) {
        alert(err.message)
        this.exportLabelsPopup.loading = false
      }
    },
    getStatusText (item) {
      // const trackingStatuses = ['ready', 'in transit', 'delivered']
      // if (trackingStatuses.includes(item.status) && !!item.trackStatus) {
      return item.trackStatus
      // }
      // return item.status || 'ready'
    },
    showExportLabelsPopup () {
      this.exportLabelsPopup.show = true
    },
    isLabelOverOneWeek (item) {
      const today = new Date()
      const timeDiff = Math.abs(today.getTime() - item.createTime.getTime())
      const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24))
      return daysDiff > 7 && (item.status === 'ready' || item.status === 'in transit')
    },
    changeBatchSearch (arr = [], fieldName) {
      arr = arr.reduce((resArr, currItem) => {
        return resArr.concat(splitKeyword(currItem))
      }, [])
      this.$set(this, fieldName, arr.filter(item => item))
    },
    generatePredicate () {
      const { selectText, trackStatusValue, searchText, requestIds = [], searchTrackings = [] } = this
      const predicate = []
      const toUpperStr = str => str.trim().toUpperCase()
      if (requestIds.length) {
        predicate.push({
          field: 'requestId',
          compare: 'in',
          value: requestIds.map(toUpperStr).slice(0, 10)
        })
      }
      if (searchTrackings.length) {
        predicate.push({
          field: `trackingNumber`,
          compare: 'in',
          value: searchTrackings.map(toUpperStr).slice(0, 10)
        })
      }
      if (searchText) {
        predicate.push({
          field: `keywords`,
          compare: 'array-contains',
          value: searchText.trim().toLowerCase()
        })
      }
      if (selectText) {
        if (this.activeOrganization || this.activeWarehouse) {
          predicate.push({
            field: `status`,
            compare: '==',
            value: selectText
          })
        } else {
          // for admin
          predicate.push({
            field: `clientKey`,
            compare: '==',
            value: selectText
          })
        }
      }
      if (trackStatusValue) {
        if (this.activeOrganization || this.activeWarehouse) {
          predicate.push({
            field: `trackStatus`,
            compare: 'in',
            value: [trackStatusValue.toLowerCase(), trackStatusValue.toUpperCase()]
          })
        }
      }
      return predicate
    },
    exportLabelsToExcel (data) {
      return this.$store.dispatch('exportLabelsToExcel', data)
    },
    labelIdGenerator (qty) {
      let idSet = new Set()
      while (idSet.size < qty) {
        idSet.add(getRandomIdByTime(3))
      }
      return [...idSet]
    },
    showAddPackagingDialog () {
      this.packagingDialog = true
      this.packagingInEdit = {}
      this.isEdit = false
    },
    showEditPackagingDialog (item) {
      this.packagingDialog = true
      this.packagingInEdit = {
        ...item,
        ...this.convertPackagingSize(item, item.isMeasurementMetric, true),
        weight: this.convertWeight(item.weight, item.isMeasurementMetric),
        isMeasurementMetric: this.isMeasurementMetric
      }
      this.isEdit = true
    },
    editPackaging () {
      const {packagingInEdit, isEdit, isMeasurementMetric} = this
      if (this.packagings.some(pkg => pkg.name === packagingInEdit.name)) {
        if (!isEdit && !confirm(this.$t('confirmEditPackage'))) return
      }
      return this.$store.dispatch('editPackaging', {packagingInEdit: {...packagingInEdit, isMeasurementMetric}, isEdit})
    },
    deletePackaging (item) {
      if (!confirm(this.$t('confirmDelete', { name: 'package' }))) return Promise.resolve()
      return this.$store.dispatch('deletePackaging', item)
    },
    showCreateLabelDialog (isCopied = false) {
      if (!isCopied && this.labelInfo.packages.length !== 0) this.clearHistory()
      this.createLabelDialog = true
    },
    showCreateLabelInternationalDialog (isCopied = false) {
      if (this.isRestrictInternationalLabel && prompt(this.$t('enterAccessCode')) !== 'vite12345') return
      if (!isCopied && this.labelInfo.packages.length !== 0) this.clearHistory()
      this.createLabelInternationalDialog = true
    },
    showCreateLabelImportDialog (isCopied) {
      if (this.isRestrictInternationalLabel && prompt(this.$t('enterAccessCode')) !== 'vite12345') return
      if (!isCopied && this.labelInfo.packages.length !== 0) this.clearHistory('importUS')
      this.createLabelImportDialog = true
    },
    showCreateFreightLabelDialog (isCopied = false) {
      if (!isCopied && this.labelInfo.packages.length !== 0) this.clearHistory()
      this.isFreight = true
      this.createLabelDialog = true
    },
    showCreateAddressDialog () {
      this.createAddressDialog = true
      this.addressFunc = this.createAddress
      this.addressInEdit = {}
    },
    showEditLabelDialog (item) {
      this.editLabelDialog = true
      this.labelInEdit = {...item}
      this.labelInEdit._key = this.labelInEdit._key || item.requestId
    },
    createAddress (address) {
      return this.$store.dispatch('labelCreateAddress', {addresses: [address]})
    },
    editAddress (address) {
      return this.$store.dispatch('labelEditAddress', address)
    },
    editLabel () {
      return this.$store.dispatch('editLabel', this.labelInEdit)
        .then(() => {
          let target = this.labels.find(item => item._key === this.labelInEdit._key)
          this.$set(target, 'note', this.labelInEdit.note)
        })
    },
    showEditAddressDialog (address) {
      this.createAddressDialog = true
      this.addressInEdit = address
      this.addressFunc = this.editAddress
    },
    deleteAddress (address) {
      if (!confirm(this.$t('confirmDelete', { name: 'address' }))) return Promise.resolve()
      return this.$store.dispatch('labelDeleteAddress', address)
    },
    getLabelStatus (label) {
      return this.$store.dispatch('getLabelStatus', label)
        .then((rtn) => {
          if (!rtn.data.code) {
            rtn.data.map(label => {
              if (label.status === 'OK') {
                const idx = this.labels.findIndex(item => item.orderId === label.orderId)
                this.$set(this.labels, idx, {...this.labels[idx], ...label, status: 'ready'})
              } else if (['canceled', 'failed'].includes(label.status)) {
                const idx = this.labels.findIndex(item => item.orderId === label.orderId)
                this.$set(this.labels, idx, {...this.labels[idx], ...label, status: 'failed'})
              }
            })
          }
        })
    },
    async downloadFile (url, orderKey, key) {
      if (
        this.$store.getters.tenantLimitedInfo &&
        this.$store.getters.tenantLimitedInfo.isRenameLabelByOrderKey &&
        orderKey
      ) {
        await downloadLabelFile(url, orderKey ? `${orderKey.split('-').slice(1).join('-')}.pdf` : undefined)
      } else {
        window.open(url)
      }
      return this.$store.dispatch('updateLabelDownloadStatus', {key: key})
        .then(() => {
          const idx = this.labels.findIndex(item => item._key === key)
          if (idx === -1) return
          this.$set(this.labels, idx, {...this.labels[idx], isDownloaded: true})
        })
    },
    updateLabelStatus (rtnArray) {
      rtnArray.sort((a, b) => b._key < a._key ? -1 : 1)
      this.labels = [...rtnArray, ...this.labels]
      this.scanAndSubscribePendingLabels(rtnArray)
    },
    scanAndSubscribePendingLabels (labels = []) {
      labels.forEach(label => {
        if (!label || label.status !== 'pending' || !label.requestId) return
        this.startTempLabelStatusSubscription(label)
      })
    },
    startTempLabelStatusSubscription (label) {
      const requestId = label?.requestId
      if (!requestId || this.tempLabelStatusUnsubs[requestId]) return
      const localIdx = this.labels.findIndex(item => item.requestId === requestId || item._key === requestId)
      if (localIdx === -1) return
      this.$set(this.tempLabelStatusBaseline, requestId, this.labels[localIdx]?.status)
      const errorFunc = () => this.cleanupTempLabelSubscription(requestId)
      this.$store.dispatch('subscriptionLabelByRequestId', {
        requestId,
        cbFunc: (remoteLabel) => this.applyTempStatusUpdate(requestId, remoteLabel),
        errorFunc
      })
        .then(unsubscribe => {
          if (!unsubscribe) return
          this.$set(this.tempLabelStatusUnsubs, requestId, unsubscribe)
        })
        .catch(() => this.cleanupTempLabelSubscription(requestId))
    },
    applyTempStatusUpdate (requestId, remoteLabel = {}) {
      const localIdx = this.labels.findIndex(item => item.requestId === requestId || item._key === requestId)
      if (localIdx === -1) {
        this.cleanupTempLabelSubscription(requestId)
        return
      }
      const localItem = this.labels[localIdx] || {}
      const remoteStatus = remoteLabel.status
      const baselineStatus = this.tempLabelStatusBaseline[requestId]
      if (!remoteStatus || remoteStatus === baselineStatus || remoteStatus === localItem.status) return
      this.$set(this.labels, localIdx, {...localItem, ...remoteLabel, status: remoteStatus})
      this.cleanupTempLabelSubscription(requestId)
    },
    cleanupTempLabelSubscription (requestId) {
      const unsubscribe = this.tempLabelStatusUnsubs[requestId]
      if (typeof unsubscribe === 'function') unsubscribe()
      this.$delete(this.tempLabelStatusUnsubs, requestId)
      this.$delete(this.tempLabelStatusBaseline, requestId)
    },
    downloadSelectedLabelAndZip () {
      this.selectedLabels.sort((a, b) => {
        return a._key < b._key ? -1 : 1
      })
      return this.$store.dispatch('downloadSelectedLabels', {
        labels: this.selectedLabels.filter(item => item.url && item.status !== 'canceled'),
        isMergePDF: this.isMergePDF
      })
    },
    async cancelLabel (label) {
      let targetShipment = this.$store.getters.shipments.find(item => item._key === label.shipmentId)
      if (targetShipment && targetShipment.isPrinted) {
        if (confirm(this.$t('cancelShipmentApplication'))) {
          this.$store.dispatch('updateShipments', {docKey: label.shipmentId, applyForCancelShipment: true})
          alert(this.$t('cancellationRequestSubmitted'))
        }
        return Promise.resolve()
      } else if (!confirm(label.shipmentId ? this.$t('canceledShipmentId', { shipmentId: label.shipmentId }) : this.$t('confirmCancel', { name: 'label' }))) return Promise.resolve()
      try {
        this.isLoading = true
        await this.$store.dispatch('cancelLabel', label)
        this.labels
          .forEach(item => {
            if (item.requestId === label.requestId) {
              this.$set(item, 'status', 'canceled')
            }
          })
        this.isLoading = false
      } catch (err) {
        alert(err.message)
        this.isLoading = false
      }
    },
    showPathAnnouncement (path) {
      return this.$store.getters.globalFunctions.showPathAnnouncement?.(path)
    },
    checkPathAnnouncement (path) {
      return this.$store.getters.globalFunctions.checkPathAnnouncement?.(path)
    },
    copyLabel (label) {
      const {from, to, packages, commodities, shippingService, note, signature, purpose, bookingConfirmationNumber, dangerousGoods, hazMatsInfo, emergencyContactNumber, offerorName, shipmentMemo, isSupportHazmat = false, isSaturdayDelivery, labelStockType = 'STOCK_4X6', dryIceDetail = {}, batteryLabel, freightCharges, exportDetail, thirdParty, packageType, signatureCode, isPrintSafetyDocument} = label
      Object.assign(this.labelInfo, cloneDeep({from, to, packages: packages.map(({ trackingNumber, skus, ...pkg }) => ({ ...pkg, reference: pkg.dept || pkg.inv || pkg.po })), commodities, shippingService, note, signature, shipmentPurpose: purpose, bookingConfirmationNumber, dangerousGoodsInfo: {dangerousGoods, hazMatsInfo, emergencyContactNumber, offerorName, dryIceDetail, signatureCode, isPrintSafetyDocument}, isSaturdayDelivery, isSupportHazmat, labelStockType, batteryLabel, freightCharges, exportDetail, thirdParty, packageType}))
      this.labelInfo.memo = shipmentMemo
      const internationalLabelServices = this.$store.state.setting.internationalLabelServices.reduce((acc, item) => {
        return [...acc, item.serviceTypes.reduce((pre, item) => [...pre, item.value], [])]
      }, []).flat(1)
      const importToUSLabelServices = this.$store.state.setting.importToUSLabelServices.reduce((acc, item) => {
        return [...acc, item.serviceTypes.reduce((pre, item) => [...pre, item.value], [])]
      }, []).flat(1)

      if (internationalLabelServices.includes(this.labelInfo.shippingService) && from.countryCode === 'US') {
        this.showCreateLabelInternationalDialog(true)
      } else if (this.$store.getters.freightShippingServices.map(ss => ss.value)?.includes(this.labelInfo.shippingService)) {
        this.showCreateFreightLabelDialog(true)
      } else if (importToUSLabelServices.includes(this.labelInfo.shippingService) && to.countryCode === 'US') {
        this.showCreateLabelImportDialog(true)
      } else {
        this.showCreateLabelDialog(true)
      }
    },
    clearHistory (type = '') {
      const payload = {
        from: {},
        to: {},
        commodities: [],
        packages: [],
        shippingService: '',
        note: '',
        memo: '',
        signature: '',
        shipmentPurpose: '',
        bookingConfirmationNumber: '',
        dangerousGoodsInfo: {},
        isSaturdayDelivery: false,
        isSupportHazmat: false,
        labelStockType: undefined
      }
      if (type === 'importUS') {
        Object.assign(payload, {
          batteryLabel: '',
          freightCharges: '',
          isThirdParty: false,
          thirdParty: {},
          exportDetail: {}
        })
      }
      Object.assign(this.labelInfo, payload)
    },
    async proofDelivery (item) {
      const { isProofDelivery, filePathDownloadURL } = item
      if (isProofDelivery) {
        this.downloadPoofDeliveryFile(filePathDownloadURL)
        return
      }
      if (!confirm(this.$t('confirmProofDelivery'))) return
      await this.getProofDeliveryFile(item)
    },
    async updateProofDelivery (item) {
      const { isProofDelivery } = item
      if (!isProofDelivery || !confirm(this.$t('confirmUpdateProofDelivery'))) return
      await this.getProofDeliveryFile(item)
    },
    async getProofDeliveryFile (item) {
      const { trackingNumber, orderId } = item
      try {
        const { data = {} } = await this.$store.dispatch('getLabelProofDelivery', { trackingNumber, orderId })
        this.downloadPoofDeliveryFile(data.filePathDownloadURL)
        this.$set(item, 'isProofDelivery', true)
        item.filePathDownloadURL = data.filePathDownloadURL
      } catch (err) {
        let msg = err.message
        if (msg.includes('is not currently available')) msg = this.$t('proofDeliveryError')
        console.log(msg)
        alert(msg)
      }
    },
    downloadPoofDeliveryFile (fullPath, fileName) {
      if (!fullPath) return
      const link = document.createElement('a')
      link.href = fullPath
      link.style.display = 'none'
      link.download = fileName
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    getPackagingWeightForDisplay (pkg) {
      if (!pkg || !pkg.weight) return '-'
      const weight = this.convertWeight(pkg.weight, pkg.isMeasurementMetric)
      return `${weight} ${this.isMeasurementMetric ? 'kg' : 'lb'}`
    }
  }
}
</script>

<style scoped>
  .flash_alert{
    background-color: inherit !important;
    color: red;
    border: 0px;
  }

  .fontRed {
    color: red;
  }

  .fontGreen {
    color: green;
  }
  .list-tile-center /deep/ .v-list__tile {
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Label.vue